<template>
	<div id="UILayers">
		<button id="addlayer" class="ui_big_button" v-on:click="addLayer()">
			Add layer
		<div class="ui_big_button_icon plus"></div>
		</button>


		
		

		<div class="UI_items layers">

			<div v-for="(layer, indexLayer) in okanMap.layers" v-bind:key="indexLayer"
			v-bind:class="{
				['UI_item layer'] : true,
				['open'] : layer.expanded
			}"
			>
				<div
				v-bind:class="{
					['UI_item_header'] : true,
					['open'] : layer.expanded
				}">
					<div class="delete_small layers" v-on:click="deleteLayer(layer)"></div>
					<div class="UI_item_open" 
					v-on:click="layer.expanded = !layer.expanded; okanMap.layers.forEach((l) => { if(l.id != layer.id) {l.expanded = false} }); "></div>
					<div class="UI_item_header_title">
						<span  >
							{{layer.name}}
						</span>
						
						
						<label class="switch switchlayer">
							<input type="checkbox" v-on:change="visibility(layer)" v-model="layer.visible" />
							<span class="slider round"></span>
						</label>
					</div>
					
					
					
				</div>
				<div
				class="UI_item_layer_content"
						v-if="layer.expanded">
						<div style="text-align:right">
							<button class="button_bringtop"
							v-on:click="bringToTop(layer)">Bring to top</button>
						</div>
						

						<h4 class="fhh">Layer Name</h4>
						<input type="text" class="layernameinput" v-model="layer.name" />

						<h4 class="fhh">Layer type</h4>

						<div class="layerTypeSelect_wrap">
							<label 
							v-for="(layerType, layerTypeIndex) in layer.layerTypeParams"
							v-bind:key="layerTypeIndex"
							v-bind:class="{
								['layerTypeSelect_label'] : true,
								[layerType.name] : true
							}"
							>
								<input type="radio" 
								v-bind:name="layer.mapLayerName"
								v-bind:value="layerTypeIndex"
								v-model="layer.typeIndex"
								v-on:change="changeType(layer)"
								/>
								<div class="imgtypelayer"></div>
								<p>{{layerType.name}}</p>
							</label>
						</div>

						<div class="layerSourceSelect_wrap">
							<hr />
							<h4>Layer source</h4>
							<select class="layerSourceSelect" 
							v-model="layer.sourceIndex" 
							v-on:change="changeLayerSource(layer)">
								<option 
								v-for="(source, sourceIndex) in okanMap.sources"
								v-bind:key="sourceIndex"
								v-bind:value="sourceIndex">
									{{source.name}} <small>({{source.data.features.length}})</small>
								</option>				
							</select>
						</div>
						

						<hr />
						<div
						v-bind:class="{
							['expandable'] : true,
							['open'] : appearence_open
						}">
							<h4 v-on:click="appearence_open = !appearence_open">Appearance Settings</h4>
							<!-- ################################################ -->
							<!--                    PARAM POINT                   -->
							<!-- ################################################ -->
							<div class="pointsParams" v-if="layer.typeIndex == 0">		

								<layerParam 
								v-bind:okanMap="okanMap"
								v-bind:layer="layer"
								v-bind:params="['mapAligned']"
								v-bind:title="'Map-aligned ?'"
								v-bind:type="'mapalign'"
								v-on:changeMapAlign="changeValue"
								/>

								<layerParam 
								v-bind:okanMap="okanMap"
								v-bind:layer="layer"
								v-bind:params="['clustered']"
								v-bind:title="'Clustered ?'"
								v-bind:type="'clusterbool'"
								v-on:changeCluster="changeCluster"
								/>
								
								<div class="layerparam_group">
									
									<h5>Circle appereance</h5>
									
									<layerParam 
									v-bind:okanMap="okanMap"
									v-bind:layer="layer"
									v-bind:params="['radius']"
									v-bind:title="'Radius'"
									v-bind:type="'float'"
									v-on:changeVal="changeValue"
									/>

									<layerParam 
									v-bind:okanMap="okanMap"
									v-bind:layer="layer"
									v-bind:params="['appearance', 'background', 'color']"
									v-bind:title="'Background color'"
									v-bind:type="'color'"
									/>

									<layerParam 
									v-bind:okanMap="okanMap"
									v-bind:layer="layer"
									v-bind:params="['appearance', 'background', 'opacity']"
									v-bind:title="'Background opacity'"
									v-bind:type="'float'"
									v-on:changeVal="changeValue"
									/>

									<layerParam 
									v-bind:okanMap="okanMap"
									v-bind:layer="layer"
									v-bind:params="['appearance', 'stroke', 'width']"
									v-bind:title="'Stroke width'"
									v-bind:type="'float'"
									v-on:changeVal="changeValue"
									/>

									<layerParam 
									v-bind:okanMap="okanMap"
									v-bind:layer="layer"
									v-bind:params="['appearance', 'stroke', 'color']"
									v-bind:title="'Stroke color'"
									v-bind:type="'color'"
									/>

									<layerParam 
									v-bind:okanMap="okanMap"
									v-bind:layer="layer"
									v-bind:params="['appearance', 'stroke', 'opacity']"
									v-bind:title="'Stroke opacity'"
									v-bind:type="'float'"
									v-on:changeVal="changeValue"
									/>

								</div>
								
								<div class="layerparam_group" v-if="params(layer).clustered == true">

									<h5>Cluster circle appereance</h5>
									
									<layerParam 
									v-bind:okanMap="okanMap"
									v-bind:layer="layer"
									v-bind:params="['clusterCircleRadius']"
									v-bind:title="'Radius'"
									v-bind:type="'float'"
									v-on:changeVal="changeValue"
									/>

									<layerParam 
									v-bind:okanMap="okanMap"
									v-bind:layer="layer"
									v-bind:params="['appearance', 'clustered', 'background', 'color']"
									v-bind:title="'Background color'"
									v-bind:type="'color'"
									/>

									<layerParam 
									v-bind:okanMap="okanMap"
									v-bind:layer="layer"
									v-bind:params="['appearance', 'clustered', 'background', 'opacity']"
									v-bind:title="'Background opacity'"
									v-bind:type="'float'"
									v-on:changeVal="changeValue"
									/>

									<layerParam 
									v-bind:okanMap="okanMap"
									v-bind:layer="layer"
									v-bind:params="['appearance', 'clustered', 'stroke', 'width']"
									v-bind:title="'Stroke width'"
									v-bind:type="'float'"
									v-on:changeVal="changeValue"
									/>

									<layerParam 
									v-bind:okanMap="okanMap"
									v-bind:layer="layer"
									v-bind:params="['appearance', 'clustered', 'stroke', 'color']"
									v-bind:title="'Stroke color'"
									v-bind:type="'color'"
									/>

									<layerParam 
									v-bind:okanMap="okanMap"
									v-bind:layer="layer"
									v-bind:params="['appearance', 'clustered', 'stroke', 'opacity']"
									v-bind:title="'Stroke opacity'"
									v-bind:type="'float'"
									v-on:changeVal="changeValue"
									/>

									<layerParam 
									v-bind:okanMap="okanMap"
									v-bind:layer="layer"
									v-bind:params="['appearance', 'clustered', 'text', 'size']"
									v-bind:title="'Text size'"
									v-bind:type="'float'"
									v-on:changeVal="changeValue"
									/>

									<layerParam 
									v-bind:okanMap="okanMap"
									v-bind:layer="layer"
									v-bind:params="['appearance', 'clustered', 'text', 'color']"
									v-bind:title="'Text color'"
									v-bind:type="'color'"
									/>

									<layerParam 
									v-bind:okanMap="okanMap"
									v-bind:layer="layer"
									v-bind:params="['appearance', 'clustered', 'text', 'opacity']"
									v-bind:title="'Text opacity'"
									v-bind:type="'float'"
									v-on:changeVal="changeValue"
									/>

								</div>
								
							</div>

							<!-- ################################################ -->
							<!--                    PARAM ZONE                    -->
							<!-- ################################################ -->
							<div class="zoneParams" v-if="layer.typeIndex == 1">

								<layerParam 
								v-bind:okanMap="okanMap"
								v-bind:layer="layer"
								v-bind:params="['extrudeHeight']"
								v-bind:title="'3D extrusion height'"
								v-bind:type="'float'"
								v-on:changeVal="changeValue"
								/>	

								<layerParam 
								v-bind:okanMap="okanMap"
								v-bind:layer="layer"
								v-bind:params="['extrudeHeightBase']"
								v-bind:title="'3D extrusion height base'"
								v-bind:type="'float'"
								v-on:changeVal="changeValue"
								/>		
								
								<div class="layerparam_group">

									<h5>Zone appereance</h5>

									<layerParam 
									v-bind:okanMap="okanMap"
									v-bind:layer="layer"
									v-bind:params="['appearance', 'background', 'color']"
									v-bind:title="'Background color'"
									v-bind:type="'color'"
									/>

									<layerParam 
									v-bind:okanMap="okanMap"
									v-bind:layer="layer"
									v-bind:params="['appearance', 'background', 'opacity']"
									v-bind:title="'Background opacity'"
									v-bind:type="'float'"
									v-on:changeVal="changeValue"
									/>

								</div>

								<div class="layerparam_group">

									<h5>Zone stroke appereance</h5>

									<layerParam 
									v-bind:okanMap="okanMap"
									v-bind:layer="layer"
									v-bind:params="['appearance', 'stroke', 'width']"
									v-bind:title="'Stroke width'"
									v-bind:type="'float'"
									v-on:changeVal="changeValue"
									/>

									<layerParam 
									v-bind:okanMap="okanMap"
									v-bind:layer="layer"
									v-bind:params="['appearance', 'stroke', 'gapWidth']"
									v-bind:title="'Stroke gap width'"
									v-bind:type="'float'"
									v-on:changeVal="changeValue"
									/>

									<layerParam 
									v-bind:okanMap="okanMap"
									v-bind:layer="layer"
									v-bind:params="['appearance', 'stroke', 'color']"
									v-bind:title="'Stroke color'"
									v-bind:type="'color'"
									/>

									<layerParam 
									v-bind:okanMap="okanMap"
									v-bind:layer="layer"
									v-bind:params="['appearance', 'stroke', 'opacity']"
									v-bind:title="'Stroke opacity'"
									v-bind:type="'float'"
									v-on:changeVal="changeValue"
									/>

									<layerParam 
									v-bind:okanMap="okanMap"
									v-bind:layer="layer"
									v-bind:params="['appearance', 'stroke', 'blur']"
									v-bind:title="'Stroke blur'"
									v-bind:type="'float'"
									v-on:changeVal="changeValue"
									/>

								</div>
								
							</div>

							<!-- ################################################ -->
							<!--                    PARAM LINE                    -->
							<!-- ################################################ -->
							<div class="lineParams" v-if="layer.typeIndex == 2">			

									<layerParam 
									v-bind:okanMap="okanMap"
									v-bind:layer="layer"
									v-bind:params="['appearance', 'stroke', 'width']"
									v-bind:title="'Width'"
									v-bind:type="'float'"
									v-on:changeVal="changeValue"
									/>

									<layerParam 
									v-bind:okanMap="okanMap"
									v-bind:layer="layer"
									v-bind:params="['appearance', 'stroke', 'gapWidth']"
									v-bind:title="'Gap width'"
									v-bind:type="'float'"
									v-on:changeVal="changeValue"
									/>

									<layerParam 
									v-bind:okanMap="okanMap"
									v-bind:layer="layer"
									v-bind:params="['appearance', 'stroke', 'color']"
									v-bind:title="'Color'"
									v-bind:type="'color'"
									/>

									<layerParam 
									v-bind:okanMap="okanMap"
									v-bind:layer="layer"
									v-bind:params="['appearance', 'stroke', 'opacity']"
									v-bind:title="'Opacity'"
									v-bind:type="'float'"
									v-on:changeVal="changeValue"
									/>

									<layerParam 
									v-bind:okanMap="okanMap"
									v-bind:layer="layer"
									v-bind:params="['appearance', 'stroke', 'blur']"
									v-bind:title="'Blur'"
									v-bind:type="'float'"
									v-on:changeVal="changeValue"
									/>
								
							</div>

							<!-- ################################################ -->
							<!--                   PARAM HEATMAP                  -->
							<!-- ################################################ -->
							<div class="lineParams" v-if="layer.typeIndex == 3">			
								
								<div class="layerparam_group">

									<layerParam 
									v-bind:okanMap="okanMap"
									v-bind:layer="layer"
									v-bind:params="['radius']"
									v-bind:title="'Heatmap radius'"
									v-bind:type="'float'"
									v-on:changeVal="changeValue"
									/>

									<layerParam 
									v-bind:okanMap="okanMap"
									v-bind:layer="layer"
									v-bind:params="['weight']"
									v-bind:title="'Heatmap weight'"
									v-bind:type="'float'"
									v-on:changeVal="changeValue"
									/>

									<layerParam 
									v-bind:okanMap="okanMap"
									v-bind:layer="layer"
									v-bind:params="['intensity']"
									v-bind:title="'Heatmap intensity'"
									v-bind:type="'float'"
									v-on:changeVal="changeValue"
									/>

									<layerParam 
									v-bind:okanMap="okanMap"
									v-bind:layer="layer"
									v-bind:params="['appearance', 'color']"
									v-bind:title="'Color'"
									v-bind:type="'color'"
									/>

									<layerParam 
									v-bind:okanMap="okanMap"
									v-bind:layer="layer"
									v-bind:params="['appearance','opacity']"
									v-bind:title="'Opacity'"
									v-bind:type="'float'"
									v-on:changeVal="changeValue"
									/>

								</div>
								
							</div>


							<hr />
						</div>
							

						<div
						v-bind:class="{
							['expandable'] : true,
							['open'] : popup_open
						}">

							<h4 v-on:click="popup_open = !popup_open">Popup window</h4>
							
							<div class="lineParams">

								<div class="layerparam_group">

									<div class="layerParam">
										<div class="layerParam_title">Popup title</div>
										<htmlComposer v-bind:okanMap="okanMap" v-bind:layer="layer" v-bind:title="true" />
									</div>

									<div class="layerParam">
										<div class="layerParam_title">Popup content</div>
										<htmlComposer v-bind:okanMap="okanMap" v-bind:layer="layer" v-bind:title="false" />
									</div>

								</div>

							</div>

							<hr />

						</div>

					</div>
			</div>

		</div>
	</div>
</template>

<script>
import layerParam from '../components/ui/layerParam.vue'
import Layer from '../models/Layer.js'
import htmlComposer from '../components/ui/htmlComposer.vue'

export default {
	name: 'UILayers',
	components: {
		layerParam,
		htmlComposer
	},
	props: {
		okanMap : Object
	},
	data: function() {
		return {

			appearence_open: true,
			popup_open :false

		}
	},
	mounted() {

	},
	created() {

	},
	destroyed() {

	},
	methods : {

		init() {
		},

		bringToTop(layer) {
			this.okanMap.bringToTop(layer);
		},

		addLayer() {
			console.log('Adding layer...')

			if(this.okanMap.sources.length > 0) {
				let layer = new Layer()
				layer.typeIndex = 0;
				layer.name = 'New Layer'
				layer.id = this.okanMap.uniqueId();
				layer.sourceIndex = this.okanMap.sources.length -1;

				//console.log(this.okanMap.sources[layer.sourceIndex].data.features[0].geometry.Type)

				if(this.okanMap.getLayerSource(layer).data.features[0].geometry.type == 'Polygon')
					layer.typeIndex = 1;
				if(this.okanMap.sources[layer.sourceIndex].data.features[0].geometry.Type == 'Polygon')
					layer.typeIndex = 1;
				this.okanMap.drawLayer(layer);
				this.okanMap.layers.push(layer);
			}
			else {
				alert('Please add at least one source before')
			}
			
			
		},

		deleteLayer(layer) {
			this.okanMap.deleteLayer(layer);
		},

		changeCluster(p) {
			console.log(p);
			this.okanMap.setLayerParam(p.layer, p.params, p.value, p.blueprint, null)
			this.okanMap.drawLayer(p.layer)
		},

		changeValue(p) {

			if(p.type == 'float')
				p.value = parseFloat(p.value)
			this.okanMap.setLayerParamMapBox(p.layer, p.params, p.value, p.blueprint);
			this.okanMap.setLayerParam(p.layer, p.params, p.value, p.blueprint, null)
		},

		changeType(layer){
			
			this.okanMap.drawLayer(layer)
			layer.expanded = false;
			setTimeout(() =>{ 
				layer.expanded = true;
			}, 600);
			
		},

		changeLayerSource(layer){
			this.okanMap.drawLayer(layer)
			console.log('Changing layer source')
		},

		visibility(layer) {

			//console.log(layer)
			var visibilityStr = 'visible';
			if(!layer.visible) {
				visibilityStr = 'none';
			}
			this.okanMap.map.setLayoutProperty(layer.mapLayerName, 'visibility', visibilityStr);
			try {
				if(layer.mapClusterLayerName.trim() != '')
					this.okanMap.map.setLayoutProperty(layer.mapClusterLayerName, 'visibility', visibilityStr);
				if(layer.mapClusterTextLayerName.trim() != '')
					this.okanMap.map.setLayoutProperty(layer.mapClusterTextLayerName, 'visibility', visibilityStr);
				if(layer.mapContourLayerName.trim() != '')
					this.okanMap.map.setLayoutProperty(layer.mapContourLayerName, 'visibility', visibilityStr);
			}
			catch(e) {
				console.log(e)
			}
			
		},

		params(layer) {

			return layer.layerTypeParams[layer.typeIndex].params;

		},

		pink(layer) {
			this.okanMap.map.setPaintProperty(layer.mapLayerName, 'circle-color', '#ff00dc');
		},

		icon(layer) {

			console.log('layers', this.okanMap.map.getStyle().layers)

			var mapboxLayer = this.okanMap.map.getStyle().layers.find(mLayer => mLayer.id == layer.mapLayerName);

			console.log(mapboxLayer);

			this.okanMap.map.moveLayer(layer.mapLayerName, 'country_label')
			//mapboxLayer.type = 'circle-clustered';

			//https://cdn4.iconfinder.com/data/icons/animal-stroke-overcolor-buttons-1/512/xxx038-512.png
		},

		getProperties(layer){
			var retour = [];
			var ref = this.okanMap.sources[layer.sourceIndex].data.features[0].properties;
			var keys = Object.keys(ref);
			keys.forEach((element => {
				if (Number(ref[element]))
					retour.push(element);
			}));
			return retour;
		},

		openGraph(layer, params) {
			// params = ['appearance', 'background', 'color' ]

			var paramsLayer = this.params(layer);

			var objectToEdit = paramsLayer;

			params.forEach((attr) => {
				objectToEdit = objectToEdit[attr]
			})
			

			// Y a t-il deja eu un graph ?
			if(objectToEdit.expression!= undefined && objectToEdit.graph != undefined)
			{
				console.log('getting old graph...')
				this.okanMap.graphComponent.originalExpression = objectToEdit.expression;
				this.okanMap.graphSave = objectToEdit.graph;
			}
			else { // first graph
				console.log('No previous graph...')
				this.okanMap.graphComponent.originalExpression = objectToEdit;
				this.okanMap.graphSave = null;
			}

			this.okanMap.graph_layer = layer;
			this.okanMap.graph_layer_params = params;
			
			this.okanMap.graph_finalNodeName = params.join(' - ');

			this.okanMap.graphOpen = true;
			this.okanMap.graphLayerId = layer.id;

			

			this.okanMap.graphComponent.init();


		}


	}
}
</script>

<style scoped src="../assets/css/ui.css"></style>